module.exports = __webpack_public_path__ + "static/media/social-500px.bcf02551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-500px.svg
// module id = 104
// module chunks = 0